<template>
  <el-container class="con">
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but5" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but5" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main style="margin-top: -10px">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>二级商户签约</span>
      <el-steps :active="4" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 填写签约信息" icon="el-icon-edit-outline"></el-step>
        <el-step title="2 签约信息确认" icon="el-icon-s-platform"></el-step>
        <el-step title="3 证照资料上传" icon="el-icon-s-check"></el-step>
        <el-step title="4 签约成功" icon="el-icon-success"></el-step>
      </el-steps>
      <div class="main">
        <img class="img" src="@/assets/images/successOrder.png" alt=""/>
        <p class="p1">签约信息传递成功，待银行审核完毕后方可进行交易！</p>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "index",
  data(){
    return{
      currentUser:'',
      saleOrgName:''
    }
  },
  computed: {
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    }
  }
}
</script>

<style scoped>
  .text{
    color: rgb(239, 51, 69);
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    margin: 0 8px;
  }
  .main{
    text-align: center;
    width: 99%;
    height: 60vh;
    border: 1px solid rgb(196, 196, 196);
    margin: 10px auto;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but5{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .img{
    margin-top: 100px;
    width: 153px;
    height: 127px;
  }
  .p1{
    margin-top: 20px;
    margin-left: 10px;
    color: rgb(239, 51, 69);
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 3px;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    max-width: 100%;
  }
</style>
